import { Flex, Typography } from '@creditas-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { JSX } from 'react';

type MessagesProps = {
  'data-testid'?: string;
  messages: {
    helperText?: string;
    error: string;
  };
  errors: any;
  name: string;
};
type Component = (props: MessagesProps) => JSX.Element;

export const Messages: Component = ({ 'data-testid': dataTestId, messages, errors, name }) => {
  return (
    <Flex data-testid={dataTestId} flexDirection="column">
      {messages?.helperText && (
        <Typography variant="bodySmRegular">{messages.helperText}</Typography>
      )}

      <ErrorMessage
        errors={errors}
        name={name}
        render={() => (
          <Typography color="error.60" paddingTop="8px" variant="bodyXsRegular">
            {messages.error}
          </Typography>
        )}
      />
    </Flex>
  );
};
